export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  DontHandleCheckoutNotAllowedInCart: 'specs.ecom.DontHandleCheckoutNotAllowedInCart',
  CartItemQuantityBadge: 'specs.ecom.CartItemQuantityBadge',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  ShowAdditionalFeesInSideCart: 'specs.ecom.ShowAdditionalFeesInSideCart',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  FixCheckoutButtonAriaLabel: 'specs.ecom.FixCheckoutButtonAriaLabel',
  RemovePmNameErrorModal: 'specs.ecom.RemovePmNameErrorModal',
  ecomCartValidationsInPurchaseFlow: 'ecomCartValidationsInPurchaseFlow',
  ecomInlineAddressSelectionInCart: 'ecomInlineAddressSelectionInCart',
  SendRemoveLineItemAnalyticsFromCart: 'specs.ecom.SendRemoveLineItemAnalyticsFromCart',
  ecomSuccessPopupUIchanges: 'ecomSuccessPopupUIchanges',
  ecomUseCartEstimationIndicators: 'ecomUseCartEstimationIndicators',
  ecomCartLineItemUpsells: 'ecomCartLineItemUpsells',
  ecomHideDeliveryErrorWhileUpdating: 'ecomHideDeliveryErrorWhileUpdating',
  ecomCartSkeletonColor: 'ecomCartSkeletonColor',
  ecomShowTotalSavings: 'ecomShowTotalSavings',
  ecomUseFullUrlInCartItemLink: 'ecomUseFullUrlInCartItemLink',
} as const;
